import AcceptOneFA from 'features/auth/resetPassword/AcceptOneFA/AcceptOneFA';
import React from 'react';

export default function AcceptChallengePage() {
  return <AcceptOneFA />;
}
